<template>
    <div>
        <buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash" @exps="exps" @save="save" @del="del"
                    ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <wTable
                        id="xpane-0"
                        :data="dataSet"
                        :loading="loading"
                        queryData="Crequire_head"
                        :header="tableHeader"
                        :option="tableOption"
                        @edits="editInfo"
                        ref="singleTable"
                        :checkflg="false"
                ></wTable>
                <!--<el-table
                        :data="dataSet"
                        ref="singleTable"
                        v-loading="loading"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        size="mini"
                        :height="tableHeight"
                        @row-click="editInfo"
                        header-row-class-name="headerclass"
                        style="width: 100%; margin-top:0px"
                >
                    <el-table-column type="selection" v-if="false"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="order_no" :label="$t('getapi[7665]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="department" :label="$t('getapi[4469]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="issue_date" :label="$t('getapi[2188]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="picker" :label="$t('getapi[7546]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="keep_person" :label="$t('getapi[4472]')"></el-table-column>
                </el-table>-->
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div>
                    <table>
                        <tr>
                            <td style="width:60px;min-width:60px">{{ $t('getapi[2180]') }}</td>
                            <td style="width:150px;min-width:150px">
                                <el-input v-model="dataDetail.Head.department" type="text" size="mini"
                                          :disabled="true"></el-input>
                            </td>
                            <td style="width:100px;min-width:100px">{{$t('getapi[7668]')}}</td>
                            <td style="width:180px;min-width:180px">
                                <el-select filterable v-model="year"  size="mini" style="margin-righ:20px">
                                    <el-option v-for="item in yearList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                </el-select>
                            </td>
                            <td style="width:60px;min-width:60px">{{$t('getapi[7665]')}}</td>
                            <td style="width:150px;min-width:150px">
                                <el-input
                                        v-model="dataDetail.Head.order_no"
                                        type="text"
                                        readonly
                                        size="mini"
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectordernum()"></i>
                                </el-input>
                            </td>
                            <td style="width:60px;min-width:60px">{{ $t('getapi[2188]') }}</td>
                            <td style="width:150px;min-width:150px">
                                <el-input v-model="dataDetail.Head.issue_date" type="text" size="mini" :disabled="true"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[7546]') }}</td>
                            <td>
                                <el-input
                                        v-model="dataDetail.Head.picker"
                                        type="text"
                                        readonly
                                        size="mini"
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectemployee1"></i>
                                </el-input>
                            </td>
                            <td>{{ $t('getapi[1864]') }}</td>
                            <td>
                                <el-input
                                        v-model="dataDetail.Head.keep_person"
                                        type="text"
                                        readonly
                                        size="mini"
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectemployee2"></i>
                                </el-input>
                            </td>
                        </tr>
                    </table>
                </div>
                <el-table
                        id="xdetilpane-0"
                        :data="dataDetail.List" :height="tableHeight - 80" size="mini" border
                          style="width: 100%; margin-top:8px" header-row-class-name="headerclass"
                        ref="singleTable1">
                    <el-table-column type="selection" v-if="false"></el-table-column>
                    <el-table-column prop="line_no" :label="$t('getapi[1297]')" width="50" align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="category_first_name" :label="$t('getapi[169]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="category_second_name" :label="$t('getapi[170]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="category_third_name" :label="$t('getapi[171]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="item_code" :label="$t('getapi[876]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="item_name" :label="$t('getapi[546]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="measure_unit" :label="$t('getapi[916]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="actual_qty" :label="$t('getapi[4591]')" align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="so_code" :label="$t('getapi[4168]')"></el-table-column>
                </el-table>
            </li>
        </ul>
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="Crequire_head" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[6688]')" queryData="Crequire_head" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>
        <selector :isVisible="false" :isBatch=false :isSplitPage=true
                  :postUrl="'/Fin/Require/GetOrderNumPopupDataList'"
                  @callback="getordernum" ref="ordernum"></selector>

        <selector :isVisible="false" :isBatch=false :isSplitPage=true
                  :postUrl="'/Fin/Require/GetPickerPopupDataList'"
                  @callback="getemployee1" ref="employee1"></selector>

        <selector :isVisible="false" :isBatch=false :isSplitPage=true
                  :postUrl="'/Fin/Require/GetKeepPersonPopupDataList'"
                  @callback="getemployee2" ref="employee2"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: '3_requireview',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3,
                    maxHeight: this.$windowSize.tableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                user: '',
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('3_requireview'), // 当前页数据量
                SelectIndexs: 0, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                dataDetail: {
                    Head: {},
                    List: []
                }, // 编辑页面数据详情
                year: '',
                yearList: [],
                scrollTop:0,
                scrollTop1:0,
            };
        },
        watch:{
            dataSet: function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initForm(0)
                })
            },
            'dataDetail.List': function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initFormRight(0)
                })
            }
        },
        mounted: function () {
            let that = this;
            that.colsort();
            that.$processdata.pushModelCache('3_requireview', that)
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username;
            let year = new Date().getFullYear()
            that.year = year
            for(let i=0;i<5;i++){
                that.yearList = [...that.yearList,{
                    value: year - i,
                    label: year - i
                }]
            }
            that.$limits.dragControllerDiv();
            that.confirmAdd();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.bodyWrapper.scrollTop =this.scrollTop1;
                }, 13)
            })
        },
        methods: {
            colsort(){
                let that = this;
                that.$loadviewfields.Fileds('Crequire_head',0,PFileds=>{
                    that.tableHeader=PFileds;
                });
            },
            sortclick(val){
                if(val==1){
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable(){
                this.$refs.ctab.clearInputs(true);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6688]"),this.$t("getapi[6685]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                //管理界面			 
                if (that.$limits.authority('plv3', 465, 1) == 0) {
                    if(that.total>0){
                        //只读权
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    else{
                        that.$refs.SetBtn.SetButtonEnable('search,refresh');
                    }
                }
                else if (that.$limits.authority('plv3', 465, 1) == 1) {			  
                    //编辑级
                   if(that.total>0){                     
                        that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                    } else {
                        that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh');
                    }
                }
                else if (that.$limits.authority('plv3', 465, 1) == 2) {
                    //删除级
                    if (!that.$limits.fnIsEmpty(that.dataDetail.Head.order_no)) {
                        if(that.total>0){
                            that.$refs.SetBtn.SetButtonEnable('create,save,del,search,refresh,export');
                        }
                        else{
                            that.$refs.SetBtn.SetButtonEnable('create,save,del,search,refresh');
                        }
                    } 
                    else {
                        if(that.total>0){
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                        }
                        else{
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh');
                        }
                    }
                }
                else{
                    that.$refs.SetBtn.SetButtonEnable('search,refresh');
                }
            },
            btnauthority() {
                let that = this;
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('3_requireview',val)
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'Crequire_head');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/Fin/Require/GetCrequireView', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                    }
                });
            },
            // 根据ID获取详情数据
            editInfo(row) {
                let that = this;
                if(that.code == row.order_no){
                    return
                }
                that.addoredit = 2;
                that.code = row.order_no
                that.getDetail(row.order_no);
            },
            // 获取详情数据
            getDetail(code) {
                let that = this;
                let parm = {
                    Code: code
                };
                that.$http.urlpost('/Fin/Require/GetRequireBillInfoByCode', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent;
                        that.dataDetail.Head.isadd = 0
                        that.oldDataDetail = JSON.stringify(that.dataDetail)
                        that.authority();
                    }
                });
            },
            // 新增
            add() {
                let that = this;
                if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.confirmAdd()
                        });
                } else {
                    that.confirmAdd()
                }
            },
            confirmAdd(){
                let that = this;
                let datetime = Common.methods.getDatetime()
                that.isEdit = false;
                that.isShowEdit = true;
                that.addoredit = 1;
                that.code = ''
                that.dataDetail = {
                    Head: {
                        order_no: "",
                        department: "研发部",
                        issue_date: "",
                        picker: "",
                        keep_person: "",
                        isadd: 1
                    },
                    List: []
                };
                that.dataDetail = {...that.dataDetail};
                that.oldDataDetail = JSON.stringify(that.dataDetail)
                that.authority();
            },
            // 刷新
            reflash() {
                let that = this;
                if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            if(that.addoredit == 2){
                                that.getView();
                                that.getDetail(that.code)
                            } else {
                                that.getView();
                                that.confirmAdd()
                            }
                        });
                } else {
                    if(that.addoredit == 2){
                        that.getView();
                        that.getDetail(that.code)
                    } else {
                        that.getView();
                        that.confirmAdd()
                    }
                }
            },
            // 导出
            exps() {
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.$http.urlpost('/Fin/Require/GetCrequireViewToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "Crequire_head",
                    fromname: that.$t('getapi[6688]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            // 保存
            save() {
                let that = this;
                that.$refs.SetBtn.SetOneBtnEnable('save', false);
                let parm = that.dataDetail;
                that.$http.urlpost('/Fin/Require/RequireSaveData', parm, function (res) {
                    if (res.Success == 1) {
                        that.code = res.UniqueNum
                        that.getDetail(res.UniqueNum)
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                    }
                });
                that.$refs.SetBtn.SetOneBtnEnable('save', true);
            },
            selectordernum(){
              let that = this
              let param = {
                  year: that.year
              }
                that.$refs.ordernum.clearInput(true, param);
            },
            getordernum(data){
                let that = this;
                console.log(data)
                that.dataDetail.Head.order_no = data.order_no
                that.dataDetail.Head.issue_date = data.finance_date
                let parm = {
                    Code: data.order_no
                }
                that.getLists(parm)
            },
            getLists(parm) {
                let that = this
                that.$http.urlpost('/Fin/Require/GetRequireLineBySeletor', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail.List = res.DataContent.List
                    }
                });
            },
            //选择领料人
            selectemployee1() {
                let that = this;
                that.$refs.employee1.clearInput(true);
            },
            // 领料人
            getemployee1(data) {
                let that = this;
                console.log(data)
                that.dataDetail.Head.picker = data.name
            },
            //选择保管员
            selectemployee2() {
                let that = this;
                let param = {
                    year: that.year
                }
                that.$refs.employee2.clearInput(true,param);
            },
            // 保管员
            getemployee2(data) {
                let that = this;
                that.dataDetail.Head.keep_person = data.name
            },
            // 删除单据
            del() {
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            Code: that.code
                        }
                        that.$http.urlpost('/Fin/Require/DeleteRequirOrder', parm, function (res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                                that.getView()
                                that.confirmAdd()
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            checkDataChange(){
                let that = this
                //如果无保存权限，直接关闭
                if(that.$limits.authority('plv3', 465,1) < 1){
                    return false
                }
                let flag =  that.oldDataDetail != JSON.stringify(that.dataDetail)
                return flag
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    /deep/ .gray {
        background: #cac6c6;
    }
</style>
